(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[115],{

/***/ 60530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HeadingBlock_HeadingBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/HeadingBlock/HeadingBlock.module.scss
var HeadingBlock_module = __webpack_require__(43702);
var HeadingBlock_module_default = /*#__PURE__*/__webpack_require__.n(HeadingBlock_module);
// EXTERNAL MODULE: ./src/themes/kultour/components/cms/TitleDecoration/index.tsx + 1 modules
var TitleDecoration = __webpack_require__(97946);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/HeadingBlock/HeadingBlock.tsx



var HeadingBlock = function(param) {
    var importance = param.importance, heading = param.heading, addon = param.addon, decoration = param.decoration;
    var HeaderTag = "h".concat(importance);
    var subTitleSpacing = addon !== undefined ? "me-3" : "";
    // const overlap = false
    var mb = "default";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-".concat(mb, " ").concat((HeadingBlock_module_default()).root),
        children: [
            decoration && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleDecoration/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTag, {
                    className: subTitleSpacing,
                    dangerouslySetInnerHTML: {
                        __html: heading
                    }
                })
            }),
            addon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeadingBlock_module_default()).subTitle,
                dangerouslySetInnerHTML: {
                    __html: addon
                }
            })
        ]
    });
};
/* harmony default export */ var HeadingBlock_HeadingBlock = (HeadingBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/HeadingBlock/index.ts



/***/ }),

/***/ 26308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CmsPage_CmsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/GridBlock/GridBlock.tsx
// import styles from './GridBlock.module.scss'



var GridBlock = function(param) {
    var data = param.data, cmsConfig = param.cmsConfig, travelTypes = param.travelTypes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
        children: data.columns.map(function(column, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: 12,
                lg: 6,
                children: column.contentBlockAssignments.map(function(assignment, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsContentBlock_CmsContentBlock, {
                        type: assignment.type,
                        block: assignment.block,
                        cmsConfig: cmsConfig,
                        withGridWrap: false,
                        travelTypes: travelTypes
                    }, index);
                })
            }, index);
        })
    });
};
/* harmony default export */ var GridBlock_GridBlock = (GridBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/GridBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/HeadingBlock/index.ts + 1 modules
var HeadingBlock = __webpack_require__(60530);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TextWithIconBlock/index.ts + 1 modules
var TextWithIconBlock = __webpack_require__(41581);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TextWithImageBlock/TextWithImageBlock.module.scss
var TextWithImageBlock_module = __webpack_require__(8356);
var TextWithImageBlock_module_default = /*#__PURE__*/__webpack_require__.n(TextWithImageBlock_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(6498);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TextWithImageBlock/TextWithImageSlider/index.tsx + 1 modules
var TextWithImageSlider = __webpack_require__(20331);
// EXTERNAL MODULE: ./src/themes/kultour/components/elements/buttons/CardButton/index.tsx + 1 modules
var CardButton = __webpack_require__(70974);
// EXTERNAL MODULE: ./src/lib/helpers/travel.ts
var helpers_travel = __webpack_require__(87086);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app/providers/CmsProvider.tsx
var CmsProvider = __webpack_require__(76632);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TextWithImageBlock/TextWithImageBlock.tsx










var TextWithImageBlock = function(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle, _text = param.text, text = _text === void 0 ? "" : _text, _imagePosition = param.imagePosition, imagePosition = _imagePosition === void 0 ? "left" : _imagePosition, _imageFixedAspectRatio = param.imageFixedAspectRatio, imageFixedAspectRatio = _imageFixedAspectRatio === void 0 ? false : _imageFixedAspectRatio, gallery = param.gallery, link = param.link;
    var imageColOptions = imagePosition === "left" ? {
        span: 6
    } : {
        span: 6,
        order: 2
    };
    var context = (0,react.useContext)(CmsProvider/* CmsContext */.T);
    if (!context) {
        throw new Error("no CmsProvider found");
    }
    var getPageUrl = context.getPageUrl;
    var imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "box-ratio-16-9",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "box-ratio-inner ".concat((TextWithImageBlock_module_default()).imgWrap)
        })
    });
    if (gallery.images.length > 1) {
        imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWithImageSlider/* default */.Z, {
            gallery: gallery,
            fixedAspectRatio: imageFixedAspectRatio
        });
    } else if (gallery.images[0]) {
        // simple image
        var image = gallery.images[0];
        imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "box-ratio-16-9",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "box-ratio-inner ".concat((TextWithImageBlock_module_default()).imgWrap),
                children: imageFixedAspectRatio ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                    image: image,
                    width: 704,
                    aspectRatio: 1.777,
                    responsive: false,
                    className: "card-img"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            image: image,
                            width: 704,
                            aspectRatio: 1.777,
                            responsive: false,
                            className: "card-img d-lg-none"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            image: image,
                            width: 704,
                            aspectRatio: 1.1,
                            responsive: false,
                            className: "card-img d-none d-xl-block"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            image: image,
                            width: 704,
                            aspectRatio: 0.8,
                            responsive: false,
                            className: "card-img d-none d-lg-block d-xl-none"
                        })
                    ]
                })
            })
        });
    }
    var linkComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (link.label && (link.url || link.pageId || link.travelId)) {
        var href = undefined;
        switch(link.type){
            case "url":
                href = link.url;
                break;
            case "page":
                href = link.page && link.page.onlineStatus !== "OFFLINE" ? getPageUrl(link.page.id) : undefined;
                break;
            case "travel":
                href = (0,helpers_travel/* isTravelOnline */.ru)(link.travel, true) ? "tour/" + link.travel.seoSettings.urlSlug : undefined;
        }
        linkComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(CardButton/* default */.Z, {
            label: link.label,
            href: href,
            targetBlank: link.targetBlank,
            className: (TextWithImageBlock_module_default()).ribbon
        });
        // don't link slider images
        if (gallery.images.length <= 1 && href) {
            imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: link.targetBlank ? "_blank" : "_self",
                    "aria-label": link.label,
                    children: imageComponent
                })
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            className: "".concat((TextWithImageBlock_module_default()).root, " ").concat(imagePosition === "left" ? (TextWithImageBlock_module_default()).left : (TextWithImageBlock_module_default()).right, " ").concat(link.url ? (TextWithImageBlock_module_default()).withLink : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: "gx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        lg: imageColOptions,
                        children: imageComponent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        lg: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                            className: (TextWithImageBlock_module_default()).body,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                    dangerouslySetInnerHTML: {
                                        __html: title
                                    }
                                }),
                                subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (TextWithImageBlock_module_default()).subTitle,
                                    dangerouslySetInnerHTML: {
                                        __html: subtitle
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                    as: "div",
                                    className: (TextWithImageBlock_module_default()).cardText,
                                    dangerouslySetInnerHTML: {
                                        __html: text
                                    }
                                }),
                                linkComponent
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TextWithImageBlock_TextWithImageBlock = (TextWithImageBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TextWithImageBlock/index.ts


// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TextBlock/TextBlock.module.scss
var TextBlock_module = __webpack_require__(20439);
var TextBlock_module_default = /*#__PURE__*/__webpack_require__.n(TextBlock_module);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TextBlock/TextBlock.tsx


var TextBlock = function(param) {
    var _text = param.text, text = _text === void 0 ? "" : _text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TextBlock_module_default()).root,
        children: text
    });
};
/* harmony default export */ var TextBlock_TextBlock = (TextBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TextBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/WysiwygBlock/WysiwygBlock.module.scss
var WysiwygBlock_module = __webpack_require__(23911);
var WysiwygBlock_module_default = /*#__PURE__*/__webpack_require__.n(WysiwygBlock_module);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/WysiwygBlock/WysiwygBlock.tsx


var WysiwygBlock = function(param) {
    var _html = param.html, html = _html === void 0 ? "" : _html;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (WysiwygBlock_module_default()).root,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
/* harmony default export */ var WysiwygBlock_WysiwygBlock = (WysiwygBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/WysiwygBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/AccordionBlock/AccordionBlock.module.scss
var AccordionBlock_module = __webpack_require__(68372);
var AccordionBlock_module_default = /*#__PURE__*/__webpack_require__.n(AccordionBlock_module);
// EXTERNAL MODULE: ./src/components/elements/Accordion/index.ts + 1 modules
var Accordion = __webpack_require__(76144);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/AccordionBlock/AccordionBlock.tsx



var AccordionBlock = function(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
        items: items,
        className: (AccordionBlock_module_default()).root
    });
};
/* harmony default export */ var AccordionBlock_AccordionBlock = (AccordionBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/AccordionBlock/index.ts


// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/PageHeaderBlock/PageHeaderBlock.module.scss
var PageHeaderBlock_module = __webpack_require__(32570);
var PageHeaderBlock_module_default = /*#__PURE__*/__webpack_require__.n(PageHeaderBlock_module);
// EXTERNAL MODULE: ./src/components/elements/media/ResponsiveHeaderImage/ResponsiveHeaderImage.module.scss
var ResponsiveHeaderImage_module = __webpack_require__(67127);
var ResponsiveHeaderImage_module_default = /*#__PURE__*/__webpack_require__.n(ResponsiveHeaderImage_module);
// EXTERNAL MODULE: ./src/components/elements/ImageGradientOverlay/index.tsx + 1 modules
var ImageGradientOverlay = __webpack_require__(97445);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint.tsx
var useBreakpoint = __webpack_require__(24810);
;// CONCATENATED MODULE: ./src/components/elements/media/ResponsiveHeaderImage/ResponsiveHeaderImageCut.tsx



// import CloudinaryImageSrcSet from '@/components/elements/media/CloudinaryImageSrcSet'



var versions = [
    {
        name: "xs",
        height: 750,
        width: 576,
        defaultAspectRatio: undefined,
        sidebarAspectRatio: undefined
    },
    {
        name: "sm",
        height: 750,
        width: 768,
        defaultAspectRatio: undefined,
        sidebarAspectRatio: undefined
    },
    {
        name: "md",
        height: 800,
        width: 922,
        defaultAspectRatio: undefined,
        sidebarAspectRatio: undefined
    },
    {
        name: "lg",
        height: 800,
        width: 1200,
        defaultAspectRatio: undefined,
        sidebarAspectRatio: 1.125
    },
    {
        name: "xl",
        height: 750,
        width: 1400,
        defaultAspectRatio: 1.777,
        sidebarAspectRatio: 1.315
    },
    {
        name: "xxl",
        height: 800,
        width: 1650,
        defaultAspectRatio: 1.777,
        sidebarAspectRatio: 1.6
    },
    {
        name: "fhd",
        height: 750,
        width: 1920,
        defaultAspectRatio: 1.777,
        sidebarAspectRatio: 1.821
    },
    {
        name: "uw",
        height: 750,
        width: 2560,
        defaultAspectRatio: 1.777,
        sidebarAspectRatio: 2.45
    }, 
];
var isDefault = function(currentBreakpoint, imageBreakpoint) {
    if (currentBreakpoint) {
        return false;
    }
    if (imageBreakpoint === "xs") {
        return true;
    }
};
var ResponsiveHeaderImageCut = function(param) {
    var image = param.image, _lazyload = param.lazyload, lazyload = _lazyload === void 0 ? false : _lazyload, _withSidebar = param.withSidebar, withSidebar = _withSidebar === void 0 ? false : _withSidebar;
    var currentBreakpoint = (0,useBreakpoint/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ResponsiveHeaderImage_module_default()).root,
        children: [
            versions.map(function(version, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: (currentBreakpoint === version.name || isDefault(currentBreakpoint, version.name)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                        image: image,
                        height: !withSidebar && version.defaultAspectRatio ? undefined : version.height,
                        width: withSidebar && version.sidebarAspectRatio ? undefined : version.width,
                        aspectRatio: withSidebar && version.sidebarAspectRatio ? version.sidebarAspectRatio : version.defaultAspectRatio,
                        lazyload: lazyload,
                        responsive: false,
                        placeholder: false
                    }, index)
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGradientOverlay/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var ResponsiveHeaderImage_ResponsiveHeaderImageCut = (ResponsiveHeaderImageCut);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/PageHeaderBlock/PageHeaderBlock.tsx






var PageHeaderBlock = function(param) {
    var image = param.image, title = param.title, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                fluid: true,
                className: (PageHeaderBlock_module_default()).root,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "h-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "p-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveHeaderImage_ResponsiveHeaderImageCut, {
                                image: image
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-afeca152f81726ce" + " " + ((PageHeaderBlock_module_default()).content || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: title
                                    },
                                    className: "jsx-afeca152f81726ce" + " " + ((PageHeaderBlock_module_default()).title || "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    sm: 12,
                                    className: (PageHeaderBlock_module_default()).text,
                                    dangerouslySetInnerHTML: {
                                        __html: text
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "afeca152f81726ce",
                children: "main{margin-top:0}"
            })
        ]
    });
};
/* harmony default export */ var PageHeaderBlock_PageHeaderBlock = (PageHeaderBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/PageHeaderBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/ImageBlock/ImageBlock.module.scss
var ImageBlock_module = __webpack_require__(41127);
var ImageBlock_module_default = /*#__PURE__*/__webpack_require__.n(ImageBlock_module);
// EXTERNAL MODULE: ./src/integrations/cloudinary/cloudinaryUrlGenerator.ts
var cloudinaryUrlGenerator = __webpack_require__(19470);
// EXTERNAL MODULE: ./node_modules/react-parallax/lib/index.js
var lib = __webpack_require__(41113);
// EXTERNAL MODULE: ./node_modules/@cloudinary/transformation-builder-sdk/actions/resize.js + 35 modules
var resize = __webpack_require__(8045);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/ImageBlock/ImageBlock.tsx





var ImageBlock = function(param) {
    var image = param.image, text = param.text;
    var cld = cloudinaryUrlGenerator/* default */.Z;
    var myImage = cld.image(image.publicId);
    var cropSettings = (0,resize/* fill */.hl)();
    // cropSettings.width(1920)
    cropSettings.height(450);
    cropSettings.aspectRatio(4.3);
    cropSettings.gravity("auto");
    myImage.resize(cropSettings).format("auto").quality("auto");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((ImageBlock_module_default()).root),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Parallax, {
                bgImage: myImage.toURL(),
                strength: 150,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "30vh",
                        minHeight: "300px",
                        maxHeight: "350px",
                        lineHeight: 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ImageBlock_module_default()).text,
                        children: text
                    })
                })
            })
        })
    });
};
/* harmony default export */ var ImageBlock_ImageBlock = (ImageBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/ImageBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/IssuuCatalogBlock/IssuuCatalogBlock.module.scss
var IssuuCatalogBlock_module = __webpack_require__(95341);
var IssuuCatalogBlock_module_default = /*#__PURE__*/__webpack_require__.n(IssuuCatalogBlock_module);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/IssuuCatalogBlock/IssuuCatalogBlock.tsx


var IssuuCatalogBlock = function(param) {
    var publicationCode = param.publicationCode, accountName = param.accountName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (IssuuCatalogBlock_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            title: "Issuu Publication",
            sandbox: "allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox",
            allowFullScreen: true,
            src: "https://e.issuu.com/embed.html?d=".concat(publicationCode, "&u=").concat(accountName)
        })
    });
};
/* harmony default export */ var IssuuCatalogBlock_IssuuCatalogBlock = (IssuuCatalogBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/IssuuCatalogBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/EmployeesBlock/EmployeesBlock.module.scss
var EmployeesBlock_module = __webpack_require__(52695);
var EmployeesBlock_module_default = /*#__PURE__*/__webpack_require__.n(EmployeesBlock_module);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Mail.js
var Mail = __webpack_require__(26448);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/EmployeesBlock/EmployeesBlock.tsx





var EmployeesBlock = function(param) {
    var employees = param.employees;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((EmployeesBlock_module_default()).root),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: employees.map(function(employee, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    md: 6,
                    lg: 4,
                    className: "mb-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                        className: "h-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "img-ratio-1-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                    image: employee.image,
                                    aspectRatio: 1,
                                    width: 424,
                                    responsive: false,
                                    altDefault: "".concat(employee.firstName, " ").concat(employee.lastName)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                className: (EmployeesBlock_module_default()).cardBody,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                        className: (EmployeesBlock_module_default()).cardTitle,
                                        children: [
                                            employee.firstName,
                                            " ",
                                            employee.lastName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (EmployeesBlock_module_default()).jobTitle,
                                        children: employee.jobTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                        as: "div",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (EmployeesBlock_module_default()).description,
                                            children: employee.description
                                        })
                                    }),
                                    !!employee.email && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "mailto:".concat(employee.email),
                                        className: (EmployeesBlock_module_default()).contactInfo,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mail/* default */.Z, {
                                                fontSize: "small",
                                                sx: {
                                                    mr: 1
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: employee.email
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var EmployeesBlock_EmployeesBlock = (EmployeesBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/EmployeesBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/ContactBannerBlock/index.ts + 1 modules
var ContactBannerBlock = __webpack_require__(67860);
// EXTERNAL MODULE: ./src/components/models/newsletter/NewsletterForm/index.tsx + 1 modules
var NewsletterForm = __webpack_require__(89570);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/NewsletterRegistrationBlock/NewsletterRegistrationBlock.tsx



var NewsletterRegistrationBlock = function(param) {
    var fluid = param.fluid;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        fluid: true,
        className: "bg-tertiary an-wobble-horizontal-trigger",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                className: "justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: 9,
                    xl: 7,
                    className: "mt-5 mb-5 mb-md-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterForm/* default */.Z, {})
                })
            })
        })
    });
};
/* harmony default export */ var NewsletterRegistrationBlock_NewsletterRegistrationBlock = (NewsletterRegistrationBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/NewsletterRegistrationBlock/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/FormBlock/FormBlock.module.scss
var FormBlock_module = __webpack_require__(8314);
var FormBlock_module_default = /*#__PURE__*/__webpack_require__.n(FormBlock_module);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Alert.js
var Alert = __webpack_require__(88375);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 11 modules
var Form = __webpack_require__(28431);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./src/components/cms/Title/index.tsx + 1 modules
var Title = __webpack_require__(2736);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./src/components/elements/icons/ArrowIcon/index.ts + 1 modules
var ArrowIcon = __webpack_require__(66707);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./src/app/context.ts
var context = __webpack_require__(27802);
// EXTERNAL MODULE: ./src/lib/ga/gtag.ts
var gtag = __webpack_require__(64426);
// EXTERNAL MODULE: ./src/integrations/tracking/useTracking.tsx + 4 modules
var useTracking = __webpack_require__(624);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/FormBlock/FormBlock.tsx

















// language=GraphQL
var SUBMIT_CONTACT_FORM_MUTATION = "mutation SubmitContactForm($token: String!, $tenantId: ID!, $input: SubmitContactFormInput) {\n  submitContactForm(token: $token, tenantId: $tenantId, input: $input) {\n    success\n    message\n  }\n}";
var schema = es.object().shape({
    salutation: es.string().required().oneOf([
        "m",
        "f"
    ], "Select salutation"),
    firstName: es.string().required(),
    lastName: es.string().required(),
    email: es.string().required(),
    message: es.string().required()
});
var initialValues = {
    salutation: "",
    firstName: "",
    lastName: "",
    address: "",
    zip: "",
    city: "",
    phone: "",
    email: "",
    message: "",
    requestCallback: false
};
var FormBlock = function(param) {
    var formName = param.formName;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var PrivacyPolicyPageUrl = (0,react.useContext)(context/* PrivacyPolicyPageUrlContext */.U9);
    var ref = (0,react.useState)("initial"), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(t("contactForm.submitError")), errorMsg = ref1[0], setErrorMsg = ref1[1];
    var ref2 = (0,react.useState)(false), inputTracked = ref2[0], setInputTracked = ref2[1];
    var send = (0,useTracking/* useTracking */.r)().send;
    /** reCaptcha **/ var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    // Create an event handler so you can call the verification on button click event or form submit
    var handleReCaptchaVerify = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!executeRecaptcha) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        executeRecaptcha("submitContactForm")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        executeRecaptcha
    ]);
    /** Formik **/ var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: schema,
        onSubmit: function() {
            send.genericEvent({
                category: "cms_block",
                object: "contact_form",
                action: "submit",
                data: {}
            });
            handleReCaptchaVerify().then(function(token) {
                if (!token) {
                    setState("error");
                    return;
                }
                graphQLClient/* default.request */.Z.request(SUBMIT_CONTACT_FORM_MUTATION, {
                    token: token,
                    tenantId: "1",
                    input: formik.values
                }).then(function(response) {
                    formik.setSubmitting(false);
                    switch(response.submitContactForm.success){
                        case true:
                            (0,gtag/* sendFormEvent */.Hr)({
                                formName: "contact"
                            });
                            setState("success");
                            send.genericEvent({
                                category: "cms_block",
                                object: "contact_form",
                                action: "success",
                                data: {}
                            });
                            break;
                        case false:
                            setState("error");
                            send.genericEvent({
                                category: "cms_block",
                                object: "contact_form",
                                action: "error",
                                data: {}
                            });
                            switch(response.submitContactForm.message){
                                case "blocked by bot detection":
                                    setErrorMsg(t("contactForm.submitErrorBot"));
                                    break;
                            }
                            break;
                    }
                });
            });
        }
    });
    (0,react.useEffect)(function() {
        if (!inputTracked && formik.values.firstName) {
            setInputTracked(true);
            send.genericEvent({
                category: "cms_block",
                object: "contact_form",
                action: "input",
                data: {}
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formik.values.firstName
    ]);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    switch(state){
        case "success":
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    variant: "success",
                    className: "text-center mt-1 mb-3",
                    children: t("contactForm.submitSuccess")
                })
            });
            break;
        case "error":
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                variant: "danger",
                className: "text-center mt-1 mb-3",
                children: errorMsg
            });
            break;
        case "initial":
            content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                noValidate: true,
                onSubmit: formik.handleSubmit,
                "data-tr-view": "cms_block:contact_form:view",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "".concat((FormBlock_module_default()).leadText),
                            children: t("contactForm.leadText")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                sm: "4",
                                controlId: "contactFormSalutation",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control */.Z.Control, {
                                        as: "select",
                                        className: (FormBlock_module_default()).input + " " + (FormBlock_module_default()).select + " form-select",
                                        name: "salutation",
                                        placeholder: "".concat(t("contactForm.salutation"), "*"),
                                        value: formik.values.salutation,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.salutation && !!formik.errors.salutation,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                value: "",
                                                disabled: true,
                                                children: [
                                                    t("contactForm.salutation"),
                                                    " *"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "m",
                                                children: t("contactForm.mr")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "f",
                                                children: t("contactForm.mrs")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                sm: "4",
                                controlId: "contactFormFirstName",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        type: "text",
                                        name: "firstName",
                                        placeholder: "".concat(t("contactForm.firstName"), "*"),
                                        value: formik.values.firstName,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.firstName && !!formik.errors.firstName,
                                        className: (FormBlock_module_default()).input
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                sm: "4",
                                controlId: "contactFormLastName",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        type: "text",
                                        name: "lastName",
                                        placeholder: "".concat(t("contactForm.lastName"), "*"),
                                        value: formik.values.lastName,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.lastName && !!formik.errors.lastName,
                                        className: (FormBlock_module_default()).input
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                sm: 6,
                                controlId: "contactFormAddress",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        type: "text",
                                        name: "address",
                                        placeholder: "".concat(t("contactForm.address")),
                                        value: formik.values.address,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.address && !!formik.errors.address,
                                        className: (FormBlock_module_default()).input
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                xs: 4,
                                sm: 2,
                                controlId: "contactFormZip",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        type: "text",
                                        name: "zip",
                                        placeholder: "".concat(t("contactForm.zip")),
                                        value: formik.values.zip,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.zip && !!formik.errors.zip,
                                        className: (FormBlock_module_default()).input,
                                        autoComplete: "postal-code"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                xs: 8,
                                sm: 4,
                                controlId: "contactFormCity",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        type: "text",
                                        name: "city",
                                        placeholder: "".concat(t("contactForm.city")),
                                        value: formik.values.city,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.city && !!formik.errors.city,
                                        className: (FormBlock_module_default()).input
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                sm: 4,
                                controlId: "contactFormPhone",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        type: "text",
                                        name: "phone",
                                        placeholder: "".concat(t("contactForm.phone")),
                                        value: formik.values.phone,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.phone && !!formik.errors.phone,
                                        className: (FormBlock_module_default()).input
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                className: "form-group",
                                as: Col/* default */.Z,
                                sm: 8,
                                controlId: "contactFormEmail",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                        type: "text",
                                        name: "email",
                                        placeholder: "".concat(t("contactForm.email"), "*"),
                                        value: formik.values.email,
                                        onChange: formik.handleChange,
                                        isInvalid: formik.touched.email && !!formik.errors.email,
                                        className: (FormBlock_module_default()).input
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                        type: "invalid",
                                        children: [
                                            "* ",
                                            t("form.validation.required")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "form-group",
                            as: Col/* default */.Z,
                            controlId: "contactFormMessage",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    as: "textarea",
                                    rows: 5,
                                    name: "message",
                                    placeholder: "".concat(t("contactForm.message"), "*"),
                                    value: formik.values.message,
                                    onChange: formik.handleChange,
                                    isInvalid: formik.touched.message && !!formik.errors.message,
                                    className: (FormBlock_module_default()).input
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                    type: "invalid",
                                    children: [
                                        "* ",
                                        t("form.validation.required")
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: "12",
                            className: "mb-3 mb-lg-0 ".concat((FormBlock_module_default()).submitWrap),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                className: "justify-content-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xs: 12,
                                        md: "auto",
                                        className: "".concat((FormBlock_module_default()).requestCallbackWrap, " flex-fill"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                                    type: "checkbox",
                                                    id: "requestCallback",
                                                    label: t("contactForm.requestCallback"),
                                                    name: "requestCallback",
                                                    checked: formik.values.requestCallback,
                                                    onChange: formik.handleChange,
                                                    isInvalid: formik.touched.requestCallback && !!formik.errors.requestCallback
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (FormBlock_module_default()).gtcInfo,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                                                    i18nKey: "contactForm.gtcInfo",
                                                    children: [
                                                        "I accept the usage of cookies and the",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: PrivacyPolicyPageUrl,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: "privacy policy"
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                            fontsize: "9rem",
                                            className: (FormBlock_module_default()).arrow
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "submit",
                                            variant: "primary",
                                            disabled: formik.isSubmitting,
                                            children: "".concat(t("contactForm.send"))
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            });
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: "".concat((FormBlock_module_default()).root, " an-wobble-horizontal-trigger"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            className: "justify-content-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                md: 10,
                xl: 7,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* TitleH2 */.W, {
                        title: t("contactForm.contact"),
                        className: (FormBlock_module_default()).titleWrap
                    }),
                    content
                ]
            })
        })
    });
};
/* harmony default export */ var FormBlock_FormBlock = (FormBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/FormBlock/index.ts


// EXTERNAL MODULE: ./src/components/elements/sliders/SliderWithDots/index.tsx + 5 modules
var SliderWithDots = __webpack_require__(70045);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/HeaderSliderBlock/functions/buildTravelText.ts

var buildTravelText = function(travel, t) {
    // tour guides
    var text = buildGuideText(travel, t);
    if (text) {
        text += '<span class="d-sm-none"><br /></span><span class="d-none d-sm-inline-block">&nbsp;|&nbsp;</span>';
    }
    // travel dates
    text += (0,helpers_travel/* buildTravelDatesLabel */.o6)(travel.pricing.travels, t);
    return text;
};
var buildGuideText = function(travel, t) {
    var text = "";
    if (travel.travelGuides.length) {
        text = "".concat(t("with"), " ");
    }
    travel.travelGuides.forEach(function(guide, index) {
        if (index > 0) {
            text += " ".concat(t("and"), " ");
        }
        text += '<span class="text-nowrap">'.concat(guide.firstName, " ").concat(guide.lastName, "</span>");
    });
    return text;
};

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/HeaderSliderBlock/functions/index.ts

var buildSlideData = function(slide, index, t, getPageUrl) {
    var slideProps = {
        slideIndex: index
    };
    // default
    slideProps.image = slide.image;
    slideProps.title = slide.title;
    slideProps.text = slide.text;
    slideProps.link = slide.link.url;
    slideProps.targetBlank = slide.link.targetBlank;
    // Title fallback
    if (!slideProps.title || slideProps.title.length == 0) {
        switch(slide.link.type){
            case "travel":
                var ref, ref1;
                slideProps.title = slide === null || slide === void 0 ? void 0 : (ref = slide.link) === null || ref === void 0 ? void 0 : (ref1 = ref.travel) === null || ref1 === void 0 ? void 0 : ref1.name;
                break;
            case "page":
                var ref2, ref3;
                slideProps.title = slide === null || slide === void 0 ? void 0 : (ref2 = slide.link) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.page) === null || ref3 === void 0 ? void 0 : ref3.name;
        }
    }
    // Text fallback
    if (!slideProps.text || slideProps.text.length == 0) {
        switch(slide.link.type){
            case "travel":
                slideProps.text = buildTravelText(slide.link.travel, t);
                break;
        }
    }
    // Image fallback
    if (!slideProps.image || !slideProps.image.publicId) {
        switch(slide.link.type){
            case "travel":
                var ref4, ref5, ref6, ref7, ref8;
                slideProps.image = (slide === null || slide === void 0 ? void 0 : (ref4 = slide.link) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.travel) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.mainVideo) === null || ref6 === void 0 ? void 0 : ref6.publicId) ? slide.link.travel.mainVideo : slide === null || slide === void 0 ? void 0 : (ref7 = slide.link) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.travel) === null || ref8 === void 0 ? void 0 : ref8.mainImage;
                break;
            case "page":
                var ref9, ref10, ref11;
                slideProps.image = slide === null || slide === void 0 ? void 0 : (ref9 = slide.link) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.page) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.seoSettings) === null || ref11 === void 0 ? void 0 : ref11.ogImage;
                break;
        }
    }
    // Url fallback
    if (!slideProps.link || slideProps.link.length == 0) {
        switch(slide.link.type){
            case "page":
                slideProps.link = slide.link.page && slide.link.page.onlineStatus !== "OFFLINE" ? getPageUrl(slide.link.page.id) : undefined;
                break;
            case "travel":
                slideProps.link = "tour/" + slide.link.travel.seoSettings.urlSlug;
                break;
        }
    }
    return slideProps;
};

// EXTERNAL MODULE: ./src/components/models/cms/blocks/HeaderSliderBlock/HeaderSliderTeaser/HeaderSliderTeaser.module.scss
var HeaderSliderTeaser_module = __webpack_require__(63666);
var HeaderSliderTeaser_module_default = /*#__PURE__*/__webpack_require__.n(HeaderSliderTeaser_module);
;// CONCATENATED MODULE: ./src/components/elements/media/ResponsiveHeaderImage/ResponsiveHeaderImageFull.tsx



// import CloudinaryImageSrcSet from '@/components/elements/media/CloudinaryImageSrcSet'



var ResponsiveHeaderImageFull_versions = [
    {
        name: "xs",
        height: 750,
        width: 576,
        defaultAspectRatio: undefined,
        sidebarAspectRatio: undefined
    },
    {
        name: "sm",
        height: 750,
        width: 768,
        defaultAspectRatio: undefined,
        sidebarAspectRatio: undefined
    },
    {
        name: "md",
        height: 800,
        width: 922,
        defaultAspectRatio: undefined,
        sidebarAspectRatio: undefined
    },
    {
        name: "lg",
        height: 800,
        width: 1200,
        defaultAspectRatio: undefined,
        sidebarAspectRatio: 1.125
    },
    {
        name: "xl",
        height: 750,
        width: 1400,
        defaultAspectRatio: 1.777,
        sidebarAspectRatio: 1.315
    },
    {
        name: "xxl",
        height: 800,
        width: 1650,
        defaultAspectRatio: 1.777,
        sidebarAspectRatio: 1.6
    },
    {
        name: "fhd",
        height: 750,
        width: 1920,
        defaultAspectRatio: 1.777,
        sidebarAspectRatio: 1.821
    },
    {
        name: "uw",
        height: 750,
        width: 2560,
        defaultAspectRatio: 1.777,
        sidebarAspectRatio: 2.45
    }, 
];
var ResponsiveHeaderImageFull_isDefault = function(currentBreakpoint, imageBreakpoint) {
    if (currentBreakpoint) {
        return false;
    }
    if (imageBreakpoint === "xs") {
        return true;
    }
};
var ResponsiveHeaderImageFull = function(param) {
    var image = param.image, _lazyload = param.lazyload, lazyload = _lazyload === void 0 ? false : _lazyload, _withSidebar = param.withSidebar, withSidebar = _withSidebar === void 0 ? false : _withSidebar;
    var currentBreakpoint = (0,useBreakpoint/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ResponsiveHeaderImage_module_default()).root,
        children: [
            ResponsiveHeaderImageFull_versions.map(function(version, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: (currentBreakpoint === version.name || ResponsiveHeaderImageFull_isDefault(currentBreakpoint, version.name)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                        image: image,
                        height: !withSidebar && version.defaultAspectRatio ? undefined : version.height,
                        width: withSidebar && version.sidebarAspectRatio ? undefined : version.width,
                        aspectRatio: withSidebar && version.sidebarAspectRatio ? version.sidebarAspectRatio : version.defaultAspectRatio,
                        lazyload: lazyload,
                        responsive: false,
                        placeholder: false
                    }, index)
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGradientOverlay/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var ResponsiveHeaderImage_ResponsiveHeaderImageFull = (ResponsiveHeaderImageFull);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/HeaderSliderBlock/HeaderSliderTeaser/HeaderSliderTeaser.tsx





var HeaderSliderTeaser = function(param) {
    var title = param.title, link = param.link, text = param.text, image = param.image, _targetBlank = param.targetBlank, targetBlank = _targetBlank === void 0 ? false : _targetBlank, slideIndex = param.slideIndex;
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((HeaderSliderTeaser_module_default()).slideInner),
        children: [
            image && image.publicId && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveHeaderImage_ResponsiveHeaderImageFull, {
                    image: image,
                    lazyload: slideIndex > 0
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HeaderSliderTeaser_module_default()).content,
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeaderSliderTeaser_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    }),
                    text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeaderSliderTeaser_module_default()).text,
                        dangerouslySetInnerHTML: {
                            __html: text
                        }
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: link ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: link,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: targetBlank ? "_blank" : "_self",
                className: (HeaderSliderTeaser_module_default()).slideWrap,
                "data-tr-click": "cms_block:header_slider_slide_teaser:click",
                "data-tr-view": "cms_block:header_slider_slide_teaser:view",
                children: content
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (HeaderSliderTeaser_module_default()).slideWrap,
            children: content
        })
    });
};
/* harmony default export */ var HeaderSliderTeaser_HeaderSliderTeaser = (HeaderSliderTeaser);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/HeaderSliderBlock/HeaderSliderBlock.tsx













var HeaderSliderBlock = function(param) {
    var slides = param.slides;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var context = (0,react.useContext)(CmsProvider/* CmsContext */.T);
    if (!context) {
        throw new Error("no CmsProvider found");
    }
    var getPageUrl = context.getPageUrl;
    var getSlides = function(slides) {
        var slideElements = [];
        slides// filter out slides that are not online
        .filter(function(slide) {
            switch(slide.link.type){
                case "travel":
                    return (0,helpers_travel/* isTravelOnline */.ru)(slide.link.travel);
                case "page":
                    return slide.link.page && slide.link.page.onlineStatus !== "OFFLINE";
            }
        }).map(function(slide, index) {
            slideElements.push(/*#__PURE__*/ (0,react.createElement)(HeaderSliderTeaser_HeaderSliderTeaser, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buildSlideData(slide, index, t, getPageUrl)), {
                key: index
            })));
        });
        return slideElements;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                fluid: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        className: "p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderWithDots/* default */.Z, {
                            slides: getSlides(slides),
                            dotsPosition: "bottom",
                            autoplay: 8000,
                            ssr: true,
                            trackingStringPrefix: "cms_block:header_slider"
                        })
                    })
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "afeca152f81726ce",
                children: "main{margin-top:0}"
            })
        ]
    });
};
/* harmony default export */ var HeaderSliderBlock_HeaderSliderBlock = (HeaderSliderBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/HeaderSliderBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/FilterLeadFormBlock/FilterLeadFormBlock.module.scss
var FilterLeadFormBlock_module = __webpack_require__(2377);
var FilterLeadFormBlock_module_default = /*#__PURE__*/__webpack_require__.n(FilterLeadFormBlock_module);
// EXTERNAL MODULE: ./src/components/models/travel/filter/FilterLeadForm/FilterLeadForm.module.scss
var FilterLeadForm_module = __webpack_require__(34898);
var FilterLeadForm_module_default = /*#__PURE__*/__webpack_require__.n(FilterLeadForm_module);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterForm/index.ts + 3 modules
var TravelFilterForm = __webpack_require__(80814);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterInfoAndReset/index.ts + 1 modules
var TravelFilterInfoAndReset = __webpack_require__(14664);
// EXTERNAL MODULE: ./src/components/elements/media/ThemeImage/ThemeImage.tsx
var ThemeImage = __webpack_require__(38567);
;// CONCATENATED MODULE: ./src/themes/kultour/components/models/travel/filter/FilterLeadForm/FilterLeadFormSubmitButton/FilterLeadFormSubmitButton.tsx



var FilterLeadFormSubmitButton = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "an-forward mt-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeImage/* default */.Z, {
            src: "/images/elements/filter/search-label.png",
            alt: t("travelFilter.button.search"),
            width: 115,
            height: 89
        })
    });
};
/* harmony default export */ var FilterLeadFormSubmitButton_FilterLeadFormSubmitButton = (FilterLeadFormSubmitButton);

;// CONCATENATED MODULE: ./src/themes/kultour/components/models/travel/filter/FilterLeadForm/FilterLeadFormSubmitButton/index.tsx


// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/FilterLeadForm/FilterLeadForm.tsx










var FilterLeadForm = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), queryString = ref[0], setQueryString = ref[1];
    var setUrlQueryString = function(queryString) {
        setQueryString(queryString ? "?".concat(queryString) : "");
    };
    var handleChangeFilterSelection = function(queryString) {
        router.push("/tours?".concat(queryString));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "travel-filter-lead-form",
        className: (FilterLeadForm_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    lg: "3",
                    className: "".concat((FilterLeadForm_module_default()).title),
                    children: [
                        t("travelFilter.findTravel"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: "6",
                    className: (FilterLeadForm_module_default()).inputs,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelFilterForm/* default */.Z, {
                        setUrlQueryString: setUrlQueryString,
                        onChangeFilterSelection: handleChangeFilterSelection
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: "3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: (FilterLeadForm_module_default()).submitWrap,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: "auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/tours".concat(queryString),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLeadFormSubmitButton_FilterLeadFormSubmitButton, {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                className: "align-self-end mt-2 mt-lg-0 ".concat((FilterLeadForm_module_default()).resultInfoWrap),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelFilterInfoAndReset/* default */.Z, {})
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FilterLeadForm_FilterLeadForm = (FilterLeadForm);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/FilterLeadForm/index.tsx


// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(98324);
// EXTERNAL MODULE: ./src/features/travelFilter/index.ts + 1 modules
var travelFilter = __webpack_require__(32322);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/FilterLeadFormBlock/FilterLeadFormBlock.tsx







var FilterLeadFormBlock = function(param) {
    var layout = param.layout;
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var filterState = (0,hooks/* useAppSelector */.C)(travelFilter/* selectTravelFilter */.$C);
    (0,react.useEffect)(function() {
        if (!filterState.initialized) {
            dispatch((0,travelFilter/* initializeTravelFilter */.zK)({}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        fluid: true,
        className: "".concat((FilterLeadFormBlock_module_default()).root, " shadow-lg"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLeadForm_FilterLeadForm, {})
                })
            })
        })
    });
};
/* harmony default export */ var FilterLeadFormBlock_FilterLeadFormBlock = (FilterLeadFormBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/FilterLeadFormBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/TravelTypesBlock/TravelTypesBlock.module.scss
var TravelTypesBlock_module = __webpack_require__(50616);
var TravelTypesBlock_module_default = /*#__PURE__*/__webpack_require__.n(TravelTypesBlock_module);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TravelTypesBlock/TravelTypesBlock.tsx








var TravelTypesBlock = function(param) {
    var travelTypes = param.travelTypes;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TravelTypesBlock_module_default()).outer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingBlock/* default */.Z, {
                        importance: 2,
                        heading: "Reisearten",
                        addon: "Unterwegs wie es zu Ihnen passt ",
                        decoration: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "".concat((TravelTypesBlock_module_default()).root, " mb-5"),
                children: travelTypes.map(function(travelType, index) {
                    var href = "/tours?travelTypes=".concat(travelType.id);
                    var imagePosition = index % 2 === 0 ? "left" : "right";
                    var imageColOptions = imagePosition === "left" ? {
                        span: 6
                    } : {
                        span: 6,
                        order: 2
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                        className: (TravelTypesBlock_module_default()).card + " ".concat(imagePosition === "left" ? (TravelTypesBlock_module_default()).left : (TravelTypesBlock_module_default()).right),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: "gx-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: imageColOptions,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: href,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "box-ratio-16-9 ".concat((TravelTypesBlock_module_default()).imageWrap, " ").concat(imagePosition === "left" ? (TravelTypesBlock_module_default()).left : (TravelTypesBlock_module_default()).right),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "box-ratio-inner ".concat((TravelTypesBlock_module_default()).imgWrap),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                                            image: travelType.image,
                                                            width: 704,
                                                            aspectRatio: 1.777,
                                                            responsive: false,
                                                            className: "card-img d-lg-none"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                                            image: travelType.image,
                                                            width: 704,
                                                            aspectRatio: 1.4,
                                                            responsive: false,
                                                            className: "card-img d-none d-xl-block"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                                            image: travelType.image,
                                                            width: 704,
                                                            aspectRatio: 1.1,
                                                            responsive: false,
                                                            className: "card-img d-none d-lg-block d-xl-none"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        className: "".concat((TravelTypesBlock_module_default()).body),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                                children: travelType.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Text */.Z.Text, {
                                                as: "div",
                                                className: (TravelTypesBlock_module_default()).cardText,
                                                children: [
                                                    travelType.description,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardButton/* default */.Z, {
                                                        label: t("travel.showTravels"),
                                                        href: href,
                                                        className: (TravelTypesBlock_module_default()).ribbon
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var TravelTypesBlock_TravelTypesBlock = (TravelTypesBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TravelTypesBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/BestsellerSliderBlock/index.ts + 3 modules
var BestsellerSliderBlock = __webpack_require__(2273);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/features/travelFilter/gql.ts
var gql = __webpack_require__(34154);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterResultList/index.tsx + 182 modules
var TravelFilterResultList = __webpack_require__(18455);
// EXTERNAL MODULE: ./src/features/travelFilter/helpers.ts
var helpers = __webpack_require__(82700);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/PrefilteredTravelsBlock/PrefilteredTravelsBlock.tsx









var PrefilteredTravelsBlock = function(param) {
    var _destinationIds = param.destinationIds, destinationIds = _destinationIds === void 0 ? [] : _destinationIds, _travelTypeIds = param.travelTypeIds, travelTypeIds = _travelTypeIds === void 0 ? [] : _travelTypeIds, _maxResults = param.maxResults, maxResults = _maxResults === void 0 ? 0 : _maxResults;
    maxResults = maxResults > 0 ? maxResults : 100;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var filterSelections = {
        destinations: destinationIds,
        travelTypes: travelTypeIds
    };
    var ref = (0,dist/* default */.ZP)([
        gql/* TRAVEL_FILTER_QUERY */.A,
        (0,gql/* buildTravelFilterRequestVariables */.K)(filterSelections)
    ], {
        revalidateOnFocus: false
    }), data = ref.data, error = ref.error;
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (!data) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var queryString = (0,helpers/* buildTravelFilterUrlQuery */.ye)(filterSelections);
    var url = "/tours".concat(queryString ? "?".concat(queryString) : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelFilterResultList/* default */.Z, {
                travels: data.travelFilter.travels.slice(0, maxResults),
                immutable: true,
                trackingStringPrefix: "cms_block:prefiltered_travels"
            }),
            data.travelFilter.travels.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "justify-content-end mb-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: "auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                as: "a",
                                variant: "signal",
                                size: "lg",
                                className: "an-wobble-horizontal-trigger text-uppercase",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                        fontsize: "5rem",
                                        className: "me-2 overflow-hidden"
                                    }),
                                    t("moreTravels")
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var PrefilteredTravelsBlock_PrefilteredTravelsBlock = (PrefilteredTravelsBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/PrefilteredTravelsBlock/index.ts


// EXTERNAL MODULE: ./src/integrations/cloudinary/helpers.ts
var cloudinary_helpers = __webpack_require__(83391);
;// CONCATENATED MODULE: ./src/themes/kultour/components/elements/ContentDivider/ContentDivider.tsx



var ContentDivider = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: style_default().dynamic([
                    [
                        "e058945594a24612",
                        [
                            (0,cloudinary_helpers/* getCloudinaryThemeFileUrl */.k)("images/elements/divider.png")
                        ]
                    ]
                ]) + " " + "divider ".concat(className)
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "e058945594a24612",
                dynamic: [
                    (0,cloudinary_helpers/* getCloudinaryThemeFileUrl */.k)("images/elements/divider.png")
                ],
                children: ".divider.__jsx-style-dynamic-selector{text-align:center;padding:0;background-image:url(".concat((0,cloudinary_helpers/* getCloudinaryThemeFileUrl */.k)("images/elements/divider.png"), ");height:35px;background-repeat:no-repeat;background-position:center;-webkit-background-size:100%100%;-moz-background-size:100%100%;-o-background-size:100%100%;background-size:100%100%}")
            })
        ]
    });
};
/* harmony default export */ var ContentDivider_ContentDivider = (ContentDivider);

;// CONCATENATED MODULE: ./src/themes/kultour/components/elements/ContentDivider/index.ts


;// CONCATENATED MODULE: ./src/components/models/cms/blocks/DividerBlock/DividerBlock.tsx


var DividerBlock = function(param) {
    var fluid = param.fluid;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentDivider_ContentDivider, {
            className: "mt-4 mb-5",
            fluid: fluid
        })
    });
};
/* harmony default export */ var DividerBlock_DividerBlock = (DividerBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/DividerBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/travel/teasers/TravelDefaultTeaser/TravelDefaultTeaser.module.scss
var TravelDefaultTeaser_module = __webpack_require__(71951);
var TravelDefaultTeaser_module_default = /*#__PURE__*/__webpack_require__.n(TravelDefaultTeaser_module);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers_helpers = __webpack_require__(15778);
// EXTERNAL MODULE: ./src/components/elements/TeaserFlag/index.ts + 1 modules
var TeaserFlag = __webpack_require__(93150);
;// CONCATENATED MODULE: ./src/components/models/travel/teasers/TravelDefaultTeaser/TravelDefaultTeaser.tsx









var TravelDefaultTeaser = function(param) {
    var travel = param.travel, trackingStringPrefix = param.trackingStringPrefix;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/tour/".concat(travel.seoSettings.urlSlug),
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (TravelDefaultTeaser_module_default()).wrap,
                "data-tr-click": "".concat(trackingStringPrefix, "_travel_teaser:click"),
                "data-tr-view": "".concat(trackingStringPrefix, "_travel_teaser:view"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                    className: (TravelDefaultTeaser_module_default()).card + " an-up",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "img-ratio-16-9",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                                image: travel.mainImage,
                                className: "card-img",
                                altDefault: travel.name,
                                aspectRatio: 1.777,
                                width: 527,
                                responsive: false,
                                placeholderClassName: "position-absolute"
                            })
                        }),
                        travel.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(TeaserFlag/* default */.Z, {
                            text: travel.label.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                            className: (TravelDefaultTeaser_module_default()).body,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                    className: (TravelDefaultTeaser_module_default()).title,
                                    children: travel.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Text */.Z.Text, {
                                    as: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TravelDefaultTeaser_module_default()).date,
                                            dangerouslySetInnerHTML: {
                                                __html: (0,helpers_travel/* buildTravelDatesLabel */.o6)(travel.pricing.travels, t)
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TravelDefaultTeaser_module_default()).price,
                                            children: "".concat(t("booking.priceFrom"), " ").concat((0,helpers_helpers/* formatPrice */.T4)(travel.minPrice, travel.currency))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var TravelDefaultTeaser_TravelDefaultTeaser = (TravelDefaultTeaser);

;// CONCATENATED MODULE: ./src/components/models/travel/teasers/TravelDefaultTeaser/index.tsx


;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TravelSelectionBlock/TravelSelectionBlock.tsx






var TravelSelectionBlock = function(param) {
    var travels = param.travels;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: travels.filter(function(travel) {
                return (0,helpers_travel/* isTravelOnline */.ru)(travel);
            }).map(function(travel, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    md: 6,
                    lg: 4,
                    xxl: 3,
                    className: "mb-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelDefaultTeaser_TravelDefaultTeaser, {
                        travel: travel,
                        trackingStringPrefix: "cms_block:travel_selection"
                    }, index)
                }, index);
            })
        })
    });
};
/* harmony default export */ var TravelSelectionBlock_TravelSelectionBlock = (TravelSelectionBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TravelSelectionBlock/index.ts


// EXTERNAL MODULE: ./node_modules/iframe-resizer-react/dist/index.es.js
var index_es = __webpack_require__(76649);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/IframeBlock/IframeBlock.tsx



// Inject GET params to iFrame URL
var buildUrl = function(url, params) {
    return url + buildQueryString(params, url.includes("?"));
};
var buildQueryString = function(params, urlHasParams) {
    if (!Object.keys(params).length) {
        return "";
    }
    var str = [];
    for(var p in params)if (params.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
    }
    var connector = urlHasParams ? "&" : "?";
    return connector + str.join("&");
};
var IframeBlock = function(param) {
    var url = param.url, minHeight = param.minHeight;
    if (!url) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var params = {};
    if (true) {
        params = Object.fromEntries(new URL(window.location.href).searchParams);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
        xs: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
            src: buildUrl(url, params),
            style: {
                width: "1px",
                minWidth: "100%",
                minHeight: minHeight ? "".concat(minHeight, "px") : "auto"
            },
            heightCalculationMethod: "max"
        })
    });
};
/* harmony default export */ var IframeBlock_IframeBlock = (IframeBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/IframeBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/SliderBlock/SliderBlock.module.scss
var SliderBlock_module = __webpack_require__(68795);
var SliderBlock_module_default = /*#__PURE__*/__webpack_require__.n(SliderBlock_module);
// EXTERNAL MODULE: ./src/components/models/media/GallerySlider/index.ts + 1 modules
var GallerySlider = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/SliderBlock/SliderBlock.tsx



var SliderBlock = function(param) {
    var gallery = param.gallery, showDots = param.showDots, showArrows = param.showArrows, showLightbox = param.showLightbox, autoplay = param.autoplay, size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SliderBlock_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GallerySlider/* default */.Z, {
            gallery: gallery,
            sliderDotsPosition: !showDots ? "off" : undefined,
            showArrows: showArrows,
            showLightbox: showLightbox,
            autoplay: autoplay,
            trackingStringPrefix: "cms_block:slider",
            size: size
        })
    });
};
/* harmony default export */ var SliderBlock_SliderBlock = (SliderBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/SliderBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/travel/DestinationsBlock/index.tsx + 7 modules
var DestinationsBlock = __webpack_require__(54592);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/TravelGuidesBlock/TravelGuidesBlock.module.scss
var TravelGuidesBlock_module = __webpack_require__(22495);
var TravelGuidesBlock_module_default = /*#__PURE__*/__webpack_require__.n(TravelGuidesBlock_module);
// EXTERNAL MODULE: ./src/components/models/travelGuide/TravelGuideTeaser/index.tsx + 1 modules
var TravelGuideTeaser = __webpack_require__(45593);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TravelGuidesBlock/TravelGuidesBlock.tsx





var TravelGuidesBlock = function(param) {
    var travelGuides = param.travelGuides;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((TravelGuidesBlock_module_default()).root),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: travelGuides.map(function(travelGuide, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: 6,
                    xxl: 4,
                    className: "pb-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelGuideTeaser/* default */.Z, {
                        travelGuide: travelGuide
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var TravelGuidesBlock_TravelGuidesBlock = (TravelGuidesBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/TravelGuidesBlock/index.ts


// EXTERNAL MODULE: ./src/components/models/cms/blocks/BackgroundBlock/BackgroundBlock.module.scss
var BackgroundBlock_module = __webpack_require__(37274);
var BackgroundBlock_module_default = /*#__PURE__*/__webpack_require__.n(BackgroundBlock_module);
;// CONCATENATED MODULE: ./src/components/models/cms/blocks/BackgroundBlock/BackgroundBlock.tsx




var BackgroundBlock = function(param) {
    var data = param.data, cmsConfig = param.cmsConfig, travelTypes = param.travelTypes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        fluid: true,
        className: "".concat((BackgroundBlock_module_default()).root, " bg-").concat(data.backgroundVariant, " foreground-").concat(data.backgroundVariant),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                className: "p-0",
                children: data.contentBlockAssignments.map(function(assignment, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsContentBlock_CmsContentBlock, {
                        type: assignment.type,
                        block: assignment.block,
                        cmsConfig: cmsConfig,
                        travelTypes: travelTypes
                    }, index);
                })
            })
        })
    });
};
/* harmony default export */ var BackgroundBlock_BackgroundBlock = (BackgroundBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/blocks/BackgroundBlock/index.ts


;// CONCATENATED MODULE: ./src/components/models/cms/page/CmsContentBlock/CmsContentBlock.tsx































var CmsContentBlock = function(param) {
    var type = param.type, block = param.block, cmsConfig = param.cmsConfig, travelTypes = param.travelTypes, _withGridWrap = param.withGridWrap, withGridWrap = _withGridWrap === void 0 ? true : _withGridWrap;
    var element;
    var containerFluid = false;
    var addCol = true;
    var colPadding = true;
    var GridWrap = function(param) {
        var fluid = param.fluid, colPadding = param.colPadding, addCol = param.hasCol, children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            fluid: fluid,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: addCol ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    className: !colPadding ? "p-0" : "",
                    children: children
                }) : children
            })
        });
    };
    switch(type){
        case "GRID":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(GridBlock_GridBlock, {
                data: block,
                cmsConfig: cmsConfig,
                travelTypes: travelTypes
            });
            // eslint-disable-next-line react/display-name
            GridWrap = function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: children
                });
            };
            break;
        case "PAGE_HEADER":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeaderBlock_PageHeaderBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "HEADING":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingBlock/* default */.Z, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "TEXT":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlock_TextBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "WYSIWYG":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(WysiwygBlock_WysiwygBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "IMAGE":
            containerFluid = block.fluid;
            colPadding = !block.fluid;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock_ImageBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "SLIDER":
            block.fluid = true;
            containerFluid = block.fluid;
            colPadding = !block.fluid;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderBlock_SliderBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "TEXT_WITH_ICON":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWithIconBlock/* default */.Z, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "TEXT_WITH_IMAGE":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWithImageBlock_TextWithImageBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "ACCORDION":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionBlock_AccordionBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "DIVIDER":
            containerFluid = block.fluid;
            colPadding = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerBlock_DividerBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "IFRAME":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(IframeBlock_IframeBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "EMPLOYEES":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeesBlock_EmployeesBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "ISSUU_CATALOG":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(IssuuCatalogBlock_IssuuCatalogBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "CONTACT_BANNER":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactBannerBlock/* default */.Z, {
                block: block,
                cmsConfig: cmsConfig
            });
            break;
        case "NEWSLETTER_REGISTRATION":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterRegistrationBlock_NewsletterRegistrationBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "FORM":
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                reCaptchaKey: "6Ld5LugeAAAAAAg2vS31OmL2neNvTcR6AXl3r3pf",
                scriptProps: {
                    async: true,
                    defer: true,
                    appendTo: "head",
                    nonce: undefined
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBlock_FormBlock, (0,_object_spread/* default */.Z)({}, block))
            });
            break;
        case "HEADER_SLIDER":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSliderBlock_HeaderSliderBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "FILTER_LEAD_FORM":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLeadFormBlock_FilterLeadFormBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "PREFILTERED_TRAVELS":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefilteredTravelsBlock_PrefilteredTravelsBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "TRAVEL_SELECTION":
            withGridWrap = false;
            addCol = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelSelectionBlock_TravelSelectionBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "TRAVEL_TYPES":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelTypesBlock_TravelTypesBlock, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, block), {
                travelTypes: travelTypes
            }));
            break;
        case "BESTSELLER_SLIDER":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(BestsellerSliderBlock/* default */.Z, {});
            break;
        case "TRAVEL_GUIDES":
            // withGridWrap = false
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelGuidesBlock_TravelGuidesBlock, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "DESTINATIONS":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(DestinationsBlock/* default */.Z, (0,_object_spread/* default */.Z)({}, block));
            break;
        case "BACKGROUND":
            withGridWrap = false;
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundBlock_BackgroundBlock, {
                data: block,
                cmsConfig: cmsConfig,
                travelTypes: travelTypes
            });
            break;
        default:
            element = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "NOTHING"
            });
            break;
    }
    if (withGridWrap) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridWrap, {
            fluid: containerFluid,
            colPadding: colPadding,
            hasCol: addCol,
            children: element
        });
    }
    return element;
};
/* harmony default export */ var CmsContentBlock_CmsContentBlock = (CmsContentBlock);

;// CONCATENATED MODULE: ./src/components/models/cms/page/CmsContentBlock/index.ts


;// CONCATENATED MODULE: ./src/components/models/cms/page/CmsPage/CmsPage.tsx


var CmsPage = function(param) {
    var cmsPage = param.cmsPage, cmsConfig = param.cmsConfig, travelTypes = param.travelTypes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "content",
        children: cmsPage.contentBlockAssignments.map(function(assignment, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsContentBlock_CmsContentBlock, {
                type: assignment.type,
                block: assignment.block,
                cmsConfig: cmsConfig,
                travelTypes: travelTypes
            }, index);
        })
    });
};
/* harmony default export */ var CmsPage_CmsPage = (CmsPage);

;// CONCATENATED MODULE: ./src/components/models/cms/page/CmsPage/index.ts



/***/ }),

/***/ 70974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CardButton_CardButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/elements/buttons/CustomButton/index.tsx + 1 modules
var CustomButton = __webpack_require__(10926);
;// CONCATENATED MODULE: ./src/themes/kultour/components/elements/buttons/CardButton/CardButton.tsx



var CardButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var CardButton_CardButton = (CardButton);

;// CONCATENATED MODULE: ./src/themes/kultour/components/elements/buttons/CardButton/index.tsx



/***/ }),

/***/ 68372:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"AccordionBlock_root__f7hfB"};

/***/ }),

/***/ 37274:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"BackgroundBlock_root__cSfUo"};

/***/ }),

/***/ 52695:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"EmployeesBlock_root__5gB0D","cardTitle":"EmployeesBlock_cardTitle___9H9z","jobTitle":"EmployeesBlock_jobTitle__Rz8nh","cardBody":"EmployeesBlock_cardBody__XwM89","description":"EmployeesBlock_description__MvCGM","contactInfo":"EmployeesBlock_contactInfo__n_yL0"};

/***/ }),

/***/ 2377:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterLeadFormBlock_root__fG8e3"};

/***/ }),

/***/ 8314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FormBlock_root__37HoE","leadText":"FormBlock_leadText__Dcme6","gtcInfo":"FormBlock_gtcInfo__4nrAF","input":"FormBlock_input__4wrDF","select":"FormBlock_select__cGFBN","requestCallbackWrap":"FormBlock_requestCallbackWrap__0Lcbx","submitWrap":"FormBlock_submitWrap__KDrRi","arrow":"FormBlock_arrow__Ml5hj"};

/***/ }),

/***/ 63666:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slideWrap":"HeaderSliderTeaser_slideWrap__dASqQ","slideInner":"HeaderSliderTeaser_slideInner__0dKEi","content":"HeaderSliderTeaser_content__s0X5c","title":"HeaderSliderTeaser_title__fmJlB","text":"HeaderSliderTeaser_text__M4FcA"};

/***/ }),

/***/ 43702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"HeadingBlock_root__JW5C2","visible":"HeadingBlock_visible__TpH89","positioner":"HeadingBlock_positioner___Wu_T","subTitle":"HeadingBlock_subTitle__X6EPK"};

/***/ }),

/***/ 41127:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageBlock_root__XVKxb","imgWrap":"ImageBlock_imgWrap__WyBBf","text":"ImageBlock_text__u2V6k"};

/***/ }),

/***/ 95341:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IssuuCatalogBlock_root__ebSDJ"};

/***/ }),

/***/ 32570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeaderBlock_root__L3c2C","content":"PageHeaderBlock_content__3ZqyZ","title":"PageHeaderBlock_title__tRkBQ","text":"PageHeaderBlock_text__flMhS"};

/***/ }),

/***/ 68795:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"SliderBlock_root__2uSYH"};

/***/ }),

/***/ 20439:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TextBlock_root__vTGEK"};

/***/ }),

/***/ 8356:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TextWithImageBlock_root__JW_Ve","right":"TextWithImageBlock_right__r4o57","ribbon":"TextWithImageBlock_ribbon__c4ZLH","withLink":"TextWithImageBlock_withLink__wS3Cv","body":"TextWithImageBlock_body__8jil_","subTitle":"TextWithImageBlock_subTitle__SCAVl","imgWrap":"TextWithImageBlock_imgWrap__i_3C7"};

/***/ }),

/***/ 22495:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuidesBlock_root___EyH7"};

/***/ }),

/***/ 50616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelTypesBlock_root__YFBiW","card":"TravelTypesBlock_card__DbMiy","right":"TravelTypesBlock_right__CjnE5","ribbon":"TravelTypesBlock_ribbon__ObO_B","imageWrap":"TravelTypesBlock_imageWrap__Gqs6Z","body":"TravelTypesBlock_body__qj7V4","imgWrap":"TravelTypesBlock_imgWrap__fNDWu"};

/***/ }),

/***/ 23911:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"WysiwygBlock_root__cYdwN"};

/***/ }),

/***/ 34898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterLeadForm_root__6kXU7","title":"FilterLeadForm_title__j4pZc","inputs":"FilterLeadForm_inputs__s5L3_","filterOptionsWrap":"FilterLeadForm_filterOptionsWrap__i5i2U","active":"FilterLeadForm_active__ocxlS","checkbox":"FilterLeadForm_checkbox__RkMY8","input":"FilterLeadForm_input__HPpKB","resultInfo":"FilterLeadForm_resultInfo__kMxvU","submitWrap":"FilterLeadForm_submitWrap__eijGM","resultInfoWrap":"FilterLeadForm_resultInfoWrap__1_S5L","resetBtn":"FilterLeadForm_resetBtn__wofew"};

/***/ }),

/***/ 71951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TravelDefaultTeaser_wrap__Ju5_l","card":"TravelDefaultTeaser_card__Tzzj0","body":"TravelDefaultTeaser_body__Totqz","title":"TravelDefaultTeaser_title__eFjBZ","date":"TravelDefaultTeaser_date__jC1_V","price":"TravelDefaultTeaser_price__zfb_J"};

/***/ })

}]);